var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownNavy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01234 5.15227C5.6636 5.55913 5.48922 5.76257 5.28172 5.83711C5.0996 5.90253 4.90039 5.90253 4.71827 5.83711C4.51077 5.76257 4.3364 5.55914 3.98766 5.15227L1.88662 2.70106C1.28629 2.00067 0.986127 1.65048 0.978772 1.354C0.972381 1.09633 1.08558 0.850202 1.28538 0.687366C1.51527 0.5 1.9765 0.5 2.89896 0.5H7.10104C8.02349 0.5 8.48472 0.5 8.71462 0.687366C8.91441 0.850202 9.02761 1.09633 9.02122 1.354C9.01387 1.65048 8.71371 2.00067 8.11338 2.70106L6.01234 5.15227Z",
    fill: "#132E47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownNavy);
export default __webpack_public_path__ + "static/media/arrowDownNavy.ed760eaa73ef0580c549fddd83a6dba3.svg";
export { ForwardRef as ReactComponent };